(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          fetch(this.dataset.url)
            .then((response) => {
              if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`)
              return response.text()
            })
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html')
              const recommendations = html.querySelector('product-recommendations')
              if (!recommendations?.innerHTML.trim()) throw new Error('Recommendations response was empty')
              this.innerHTML = recommendations.innerHTML
              this.setAttribute('aria-busy', 'false')
            })
            .catch(() => {
              const fallback = this.querySelector('[data-recommendations-fallback]')
              if (fallback) this.innerHTML = fallback.innerHTML
              this.setAttribute('aria-busy', 'false')
            })
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();
})();
